import sessionApi from './apiClient';
import {
  AccountableDashboardSummary,
  AdminDashboardSummary,
  DashboardSummary,
  InspectorDashboardSummary,
  LogisticsDashboardSummary,
} from '../types/domain';

export const dashboardService = {
  getSummary: async (): Promise<DashboardSummary> => {
    const response = await sessionApi.get<DashboardSummary>('/dashboard/summary/');
    return response.data;
  },
  getAdminSummary: async (): Promise<AdminDashboardSummary> => {
    const response = await sessionApi.get<AdminDashboardSummary>('/dashboard/admin/');
    return response.data;
  },
  getLogisticsSummary: async (filters: { admin_department?: number } = {}): Promise<LogisticsDashboardSummary> => {
    const response = await sessionApi.get<LogisticsDashboardSummary>('/dashboard/logistics/', { params: filters });
    return response.data;
  },
  getInspectorSummary: async (): Promise<InspectorDashboardSummary> => {
    const response = await sessionApi.get<InspectorDashboardSummary>('/dashboard/inspector/');
    return response.data;
  },
  getAccountableSummary: async (filters: { admin_department?: number } = {}): Promise<AccountableDashboardSummary> => {
    const response = await sessionApi.get<AccountableDashboardSummary>('/dashboard/accountable/', { params: filters });
    return response.data;
  },
};

export type {
  AccountableDashboardSummary,
  AdminDashboardSummary,
  DashboardSummary,
  InspectorDashboardSummary,
  LogisticsDashboardSummary,
};
